import React from 'react'
import { ToastProvider } from '@moltech/molui/toast'
import { GridDefaults } from '@moltech/molui/molgrid'

import { ComponentNavigation } from './navigation/ComponentNavigation'

import AppRoutes from './navigation/AppRoutes'

import './App.scss';
import { MenuProvider } from './context/MenuContext'

import ThemeLoader  from "./components/common/ThemeLoader";

GridDefaults.set({
  grid: {
    scrollable: true,
    scrollHeight: "flex",
    filterDisplay: "row",

    sortMode: "single",
    showGridlines: true,
    resizableColumns: true,

    paginator: true,
    rowsPerPageOptions: [10, 25, 50, 100],
    rows: 25,


  },
  column: {
    defaults: {
      filter: true,
      sortable: true
    },
    datetime: {
      format: 'mm/dd/yyyy'
    }
  }
});

const App = () => {
  return (
    <>
      <ThemeLoader />
      <ToastProvider></ToastProvider>
      <MenuProvider>
        <AppRoutes componentRoutes={ComponentNavigation} />
      </MenuProvider>
    </>
  )
}

export default App